export default "__VITE_ASSET__58296542__"